import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"; // Add Navigate for redirection
import Navbar from "./components/Navbar";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Invoices from "./pages/Member"; // Members page
import InvoiceDetails from "./pages/InvoiceDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import OAuthCallback from "./pages/OAuthCallback"; // Import OAuth callback component
import { SelectedClientProvider } from "./context/SelectedClientContext"; // Import the context provider
import './css/index.css';
import { useEffect } from "react";
import Cookies from "js-cookie";
import Admin from "./pages/Admin"; // Import the Admin page
import AttachmentPreview from './pages/AttachmentPreview'; // Import the AttachmentPreview component
import CreateClient from "./pages/CreateClient"; // Import the CreateClient page
import UserActivity from "./pages/UserActivity"; // Import the UserActivity page
import EmailDetails from "./pages/EmailDetails"; // Import EmailDetails component
import VerifyEmail from "./pages/VerifyEmail"; // Import VerifyEmail component
import EmailCodeVerify from "./pages/EmailCodeVerify"; // Import EmailCodeVerify component
import ForgotPasswordCode from "./pages/ForgotPasswordCode"; // Import ForgotPasswordCode component
import VerifySuccess from "./pages/VerifySuccess"; // Import VerifySuccess component
import VerifyCodeLink from "./pages/VerifyCodeLink"; // Import VerifyCodeLink component
import VerifyMagic from "./pages/VerifyMagic"; // Import VerifyMagic component
import ResetPasswordLink from "./pages/ResetPasswordLink"; // Import ResetPasswordLink component

const App = () => {

    useEffect(() => {
        console.log("🔄 Initializing App...");
        // Check authentication status using JWT tokens
        const token = Cookies.get("token");
        const refreshToken = Cookies.get("refreshToken");
        const userId = Cookies.get("userId");

        console.log("🔍 Authentication status:", {
            hasToken: !!token,
            hasRefreshToken: !!refreshToken,
            userId: userId || "Not found"
        });

        // If no authentication tokens and no userId, user needs to login
        if (!userId && !token && !refreshToken) {
            console.warn("⚠️ No authentication credentials found. User will need to login.");
        }

        console.log("🔍 App: Reports will be fetched per client as needed");
    }, []);

    return (
        <SelectedClientProvider>
            <Router>
                <div className="app-container">
                    <Navbar />
                    <div className="content-container">
                        <Routes>
                            <Route path="/" element={<Navigate to="/members" replace />} />                            <Route path="/register" element={<Register />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/oauth-callback" element={<OAuthCallback />} />
                            {/* Admin & related routes (auth protected; component enforces admin) */}
                            <Route element={<ProtectedRoute />}>
                                <Route path="/admin" element={<Admin />} />
                                <Route path="/create-client" element={<CreateClient />} />
                                <Route path="/user-activity" element={<UserActivity />} />
                            </Route>
                            {/* Protected Routes */}
                            <Route element={<ProtectedRoute />}>
                                <Route path="/members" element={<Invoices />} />
                                <Route path="/view" element={<InvoiceDetails />} />
                                <Route path="/email/:id" element={<EmailDetails />} />
                            </Route>
                            <Route path="/preview" element={<AttachmentPreview />} />
                            <Route path="/verify-email/:token" element={<VerifyEmail />} />
                            <Route path="/verify-email-code" element={<EmailCodeVerify />} />
                            <Route path="/forgot-password-code" element={<ForgotPasswordCode />} />
                            <Route path="/verify-success" element={<VerifySuccess />} />
                            <Route path="/verify-code-link" element={<VerifyCodeLink />} />
                            <Route path="/verify-magic" element={<VerifyMagic />} />
                            <Route path="/reset-password-link" element={<ResetPasswordLink />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </div>
                </div>
            </Router>
        </SelectedClientProvider>
    );
};

export default App;
